<template>
<div class="TitleAudioVideoAdaptiveGameBar">
  <div class="border-1px">
    <!-- <div id="myNav" class="overlay overlay-overall-width-100Perc"> -->
      <!-- <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc padding-top-1Perc"> -->
        <div class="row vertical-align">  
          <div class="col-md-4 col-lg-4 padding-top-bottom-10px">
            <div class="row">
              <div class="font-size-14px create-lesson-input-text-style col-md-2 col-md-offset-1 col-lg-2 col-lg-offset-1 text-align-left padding-right-0Px padding-left-0px">
                Title
              </div>
              <div class="col-md-9 col-lg-9"></div>
            </div>
            <div class="row margin-bottom-2Perc">
              <div class="font-size-14px col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1 text-align-left padding-left-0px">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px padding-right-0px">
                    <input type="text" class="form-control" v-model="AdaptiveGameTitleValue" :maxlength="maxLength">
                  </div>
                </div>
              </div> 
            </div>
            <!-- Description start -->
            <div class="row">
              <div class="font-size-14px create-lesson-input-text-style col-md-4 col-md-offset-1 col-lg-4 col-lg-offset-1 padding-left-0px text-align-left">
               Description
              </div>
              <div class="col-md-6 col-lg-6"></div>
            </div>
            <div class="row margin-bottom-2Perc">
              <div class="col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1 padding-left-0px">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px padding-right-0px">
                    <textarea class="form-control" rows="5" v-model="AdaptiveGameDescValue"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="font-size-14px create-lesson-input-text-style col-md-4 col-md-offset-1 col-lg-4 col-lg-offset-1 padding-left-0px text-align-left">
               Duration
              </div>
              <div class="col-md-6 col-lg-6"></div>
            </div>
            <div class="row margin-bottom-2Perc">
              <div class="col-md-11 col-md-offset-1 col-lg-11 col-lg-offset-1 padding-left-0px">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px padding-right-0px">
                    <input type="text" class="form-control" placeholder="MM:SS" v-model="AdaptiveGameDurationValue">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 border-left-solid border-right-solid padding-top-bottom-10px">
            <div class="row">
              <div class="font-size-14px col-md-12 col-lg-12 text-align-left">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px padding-top-bottom-10px">
                    Video Url(s)
                  </div>
                </div>
              </div>
            </div>    
            <div class="row">
              <div class="font-size-14px col-md-12 col-lg-12 text-align-left">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-right-0px">
                    <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                    <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                    <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                  </div>
                </div>
              </div>
            </div>
            <div class="row padding-top-15px">
              <div class="font-size-14px create-lesson-input-text-style col-md-4 col-lg-4 text-align-left padding-right-0px">
                Caption File
              </div>
              <div class="col-md-8 col-lg-8 padding-Left-0px padding-right-0px">
                <!-- <div class="form-group"> -->
                  <div class="col-sm-12 padding-Left-0px padding-right-0px">
                    <input class="col-lg-12" type="file" id="vttFile" accept=".vtt">
                  </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="row">
              <div class="font-size-14px col-md-12 col-lg-12 text-align-left">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px">
                    Audio Url
                  </div>
                </div>
              </div>
            </div>    
            <div class="row">
              <div class="font-size-14px col-md-12 col-lg-12 text-align-left">
                <div class="form-group">
                  <div class="col-sm-12 padding-left-0px">
                    <input type="text" class="form-control" v-model="AudioURLValue">
                  </div>
                </div>
              </div>
            </div>    
            <div class="row padding-top-25px vertical-align">
              <div class="font-size-14px cursor-pointer col-md-12 col-lg-12 padding-left-0px">
                <div class="row vertical-align">
                  <div class="col-md-6 mol-lg-6 padding-right-0px" @click="ShowRtfEditorOverlayFlag($event,true)">
                    + Add Transcript
                  </div>
                  <div class="padding-left-0px col-md-6 mol-lg-6">
                    <input type="checkbox" class="font-weight-0 cursor-pointer" v-model="AdaptiveGameIncludeInProgress"> Include In Progress
                  </div>
                </div>
              </div>
            </div>    
          </div>
        </div>
  </div>
  <div class="row container-fluid margin-bottom-2Perc" v-if="showNextBtn">
    <div class="padding-top-2Perc">
      <button class="btn btn-primary btn-padding-6px-28px create-lesson-overlay-button-BG black-font-color" @click="CreateAdaptiveGameElement($event)">Next</button>
    </div>  
  </div>
  <div class="row">
  </div>         
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
      </div>
    <loader></loader>
    <rtf-editor-overlay v-bind:addedContent="AddContentvalue" :elementObj="elementObjValue" @showSpinner="updateShowSpinnerFlag" v-if="showRtfEditorDetails" @closeRtfEditorOverlay="updateShowRtfEditorFlag"></rtf-editor-overlay>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { elementService } from '@/server-util/element-service'
import VideoQualityControl from '@/components/VideoQualityControl'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import RtfEditorOverlay from '@/components/adaptive_game/AdaptiveGameRtfEditorOverlay'

export default {
  props: ['lessonObj'],
  created () {
    this.setModuleId()
    this.GetLearningLevels()
  },
  data: function () {
    return {
      constants: constants,
      disableInputBoxFor360And720: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showNextBtn: true,
      elementObj: {
        ModuleId: '',
        Title: '',
        Description: '',
        Duration: '',
        Type: 11,
        VideoUrl: '',
        AudioUrl: '',
        Content: '',
        IncludeInProgress: false,
        learningLevelId: '',
        LowQualityVideoUrl: '',
        HDVideoUrl: ''
      },
      responseObjectToPass: null,
      showVideoMediaController: false,
      showAudioMediaController: false,
      showRtfEditorDetails: false,
      maxLength: constants.Element_Title_Step_Max_Length
    }
  },
  name: 'TitleAudioVideoAdaptiveGameBar',
  methods: {
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.elementObj.LowQualityVideoUrl = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.elementObj.VideoUrl = videoUrl
          if (this.elementObj.VideoUrl.trim().length === 0) {
            this.elementObj.LowQualityVideoUrl = ''
            this.elementObj.HDVideoUrl = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.elementObj.HDVideoUrl = videoUrl
          break
      }
    },
    setModuleId: function () {
      this.elementObj.ModuleId = this.lessonObjValue.ModuleId
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    CreateAdaptiveGameElement: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        this.responseObjectToPass = null
        var _this = this
        var storeObj = this.$store
        _this.$store.state.isLoading = true
        var vttFileUrl = document.getElementById('vttFile').files[0]
        if (vttFileUrl === undefined && vttFileUrl === null) {
          vttFileUrl = null
        }
        this.elementObj.VideoUrl = this.elementObj.VideoUrl !== '' ? this.elementObj.VideoUrl.trim() : ''
        this.elementObj.HDVideoUrl = this.elementObj.HDVideoUrl !== '' ? this.elementObj.HDVideoUrl.trim() : ''
        this.elementObj.LowQualityVideoUrl = this.elementObj.LowQualityVideoUrl !== '' ? this.elementObj.LowQualityVideoUrl.trim() : ''
        this.elementObj.AudioUrl = this.elementObj.AudioUrl !== '' ? this.elementObj.AudioUrl.trim() : null
        const formData = new FormData()
        formData.append('elementObj', JSON.stringify(_this.elementObj))
        formData.append('VttFileInput', vttFileUrl)
        if (formData !== undefined && formData !== '' && formData !== null) {
          // AK: Start showing spinner (Course file)
          _this.$emit('showSpinner', true)
          // console.log('Print Form data', formData)
          elementService
            .createAdaptiveGameElement(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  _this.responseObjectToPass = responseObj.data
                  console.log('Create Adaptive Game Resp >> ' + JSON.stringify(_this.responseObjectToPass))
                  var objToEmit = {
                    serverResp: this.responseObjectToPassValue,
                    showStepCreationUI: true
                  }
                  _this.showNextBtn = false
                  _this.$emit('adaptiveGameRespObj', objToEmit)
                  _this.$store.state.isLoading = false
                } else {
                  // AK: Hide Spinner
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected Element Object is NULL hence declined CREATE ADAPTIVE GAME OPERATION'
          )
        }
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      // var fileUrl = document.getElementById('toolkitfile').files[0]
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.AdaptiveGameTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.AdaptiveGameDescValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Description can\'t be empty.'
        return false
      } else if ((this.AdaptiveGameDurationValue.trim().length !== 0 && this.AdaptiveGameDurationValue.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        return false
      } else if (this.elementObj.IncludeInProgress && this.elementObj.Duration.trim().length > 0 && !regex.test(this.elementObj.Duration)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length === 0 || !dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim())) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for caption.'
        return false
      } else if (this.AudioURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.AudioURLValue.trim()) || !dmAdminUtils.checkForAudioFileExtesion(this.AudioURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Audio url.'
        return false
      }
      return true
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    ShowRtfEditorOverlayFlag (event, flagToUpdate) {
      // AK: Used when user pressed Edit Course details to open Edit Course Details overlay
      this.showRtfEditorDetails = flagToUpdate
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    updateShowRtfEditorFlag (value) {
      // AK: Used to close the Edit Course Overlay
      var closeOverlay = value.closeRtfEditorOverlay
      // var transcriptText = value.transcript
      this.elementObj.Content = value.transcript
      this.showRtfEditorDetails = closeOverlay
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    GetLearningLevels: function () {
      // var _this = this
      var storeObj = this.$store
      elementService
      .getLearningLevels(storeObj.state.access_token)
      .then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // console.log('respond status', responseObj.data.CreatedTS)
          // this.learningLevelId = responseObj.data
          storeObj.state.learningLevelList = responseObj.data
        } else {
            //  Hide Spinner
            // _this.$emit('showSpinner', false)
          this.showAlertDialog = true
          this.errorMsg = 'Oops! Something went wrong. Please try again.'
        }
      }, errorObj => {
        //  Hide Spinner
        // _this.$emit('showSpinner', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'rtf-editor-overlay': RtfEditorOverlay,
    'video-quality-control': VideoQualityControl
  },
  computed: {
    elementObjValue: {
      get: function () {
        return this.elementObj
      }
    },
    VideoURLValue: {
      get: function () {
        return this.elementObj.VideoUrl
      },
      set: function (newValue) {
        this.elementObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.elementObj.HDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.elementObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.elementObj.LowQualityVideoUrl = newValue
      }
    },
    AudioURLValue: {
      get: function () {
        return this.elementObj.AudioUrl
      },
      set: function (newValue) {
        this.elementObj.AudioUrl = newValue
      }
    },
    responseObjectToPassValue: {
      get: function () {
        return this.responseObjectToPass
      }
    },
    lessonObjValue: {
      get: function () {
        return this.lessonObj
      }
    },
    AdaptiveGameTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    AdaptiveGameIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    AdaptiveGameDescValue: {
      get: function () {
        // console.log(JSON.stringify(this.elementObj))
        return this.elementObj.Description
      },
      set: function (newValue) {
        this.elementObj.Description = newValue
      }
    },
    AdaptiveGameDurationValue: {
      get: function () {
        // console.log(JSON.stringify(this.elementObj))
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    AddContentvalue: {
      get: function () {
        // console.log(JSON.stringify(this.elementObj))
        return this.elementObj.Content
      }
    },
    elementLearningLevelObjValue: {
      get: function () {
        console.log('Learning Object value', this.elementObj.learningLevelId)
        if (this.elementObj.learningLevelId !== undefined && this.elementObj.learningLevelId !== null && this.elementObj.learningLevelId !== '' && this.elementObj.learningLevelId !== 'null') {
          return this.elementObj.learningLevelId
        } else {
          return -1
        }
      },
      set: function (newValue) {
        this.elementObj.learningLevelId = newValue
      }
    },
    getLearningLevelList: {
      get: function () {
        // console.log('Learning List ++', this.$store.learningLevelList)
        return this.$store.state.learningLevelList
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.font-weight-0 {
  font-weight: 0 !important;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.border-white {
    border:1px solid white;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.font-size-12px {
  font-size:12px;
}
.padding-left-right-0px {
  padding-left:0px;
  padding-right:0px;
}
.padding-left-15px {
  padding-left: 15px;
}
.padding-left-25px {
  padding-left:25px;
}
.border-top-dotted {
  border-top: 1px dotted; 
}
.border-top-1px {
  border-top: 1px solid #aaa;
}
.border-bottom-1px {
  border-bottom: 1px solid #aaa;
}
.border-1px {
  border: 1px solid #aaa;
}
.border-right-solid {
  border-right: 1px solid #aaa;
}
.border-bottom-dotted {
  border-bottom: 1px dotted;
  border-color: #aaa;
}
.border-left-solid {
  border-left: 1px solid;
  border-color: #aaa;
}
.padding-left-12px {
  padding-left: 12px;
}
.padding-right-13px {
  padding-left: 13px;
}
.padding-left-10px {
  padding-left:10px;
}
.padding-top-9px {
  padding-top:9px;
}
.padding-top-45px {
  padding-top:45px;
}
.padding-bottom-43px {
  padding-bottom:43px;
}
.padding-top-bottom-10px {
  padding-top:10px;
  padding-bottom: 10px;
}
.padding-top-bottom-9px {
  padding-top:9px;
  padding-bottom: 9px;
}
.padding-top-17px {
  padding-top:17px;
}
.padding-bottom-54px {
  padding-bottom:54px;
}
.padding-top-54px {
  padding-top:54px;
}
.padding-bottom-10px {
  padding-bottom: 10px;
}
.text-align-left {
  text-align:left;
}
.padding-left-3px {
  padding-left:3px;
}
.padding-left-6px {
  padding-left:6px;
}
.padding-left-9px {
  padding-left:9px
}
.padding-right-20px {
  padding-right:20px;
}
.padding-top-2Perc {
  padding-top:2%;
}
.padding-right-8px {
  padding-right:8%;
}
.padding-left-21px {
  padding-left:21px;
}
.height-106px {
  height:106px;
}
.height-163px {
  height: 163px;
}
.center-content {
    margin: auto;
    width: 60%;
    border: 3px solid #73AD21;
    padding: 10px;
}
.text-vertical-center {
    padding: 69px 0;
    text-align: center;
}
.audio-text-vertical-center {
  padding: 14px 0;
  text-align: center;
}
.background-color {
  background-color: #eee;
}
.height-52px {
  height: 52px;
}
.margin-bottom-15px {
  margin-bottom: 15px;
}
.border-light-grey {
 border: 1px solid #d6d6d6;   
}
.btn-padding-6px-28px {
  padding:6px 28px;
}
.margin-bottom-2px {
  margin-bottom: 2px !important;
}
.padding-top-bottom-15px {
  padding-top:15px;
  padding-bottom:15px;
}
.padding-top-10px {
  padding-top: 10px;
}
.padding-top-15px {
  padding-top: 15px;
}
.padding-top-25px {
  padding-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/TitleAudioVideoAdaptiveGameBar.vue